import update from 'immutability-helper';
import { createReducer } from 'redux-create-reducer';
import actionsAndConstants from '../../../shared/actionsAndConstants';

const {
  app: { constants: appConstants },
  topNavbar: { constants: topNavbarConstants }
} = actionsAndConstants;

const initialState = {
  error: false,
  loading: false,
  data: {
    carrierTypes: [],
    carriers: [],
    chassisTypes: [],
    clients: [],
    containerClassifications: [],
    containerTypes: [],
    containerSizes: [],
    countries: [],
    depots: [],
    editableFields: [],
    estimationStates: [],
    movementTypes: [],
    pilots: [],
    states: []
  }
};

const loadCatalogues = state => (
  update(state, {
    $merge: {
      error: false,
      loading: true
    }
  })
);

const loadCataloguesFailed = state => (
  update(state, {
    $merge: {
      error: true,
      loading: false
    }
  })
);

const loadCataloguesSucceeded = (state, { payload: data }) => (
  update(state, {
    data: { $merge: data },
    error: { $set: false },
    loading: { $set: false }
  })
);

const logoutSucceeded = () => initialState;

const userReducer = createReducer(initialState, {
  [appConstants.loadCatalogues]: loadCatalogues,
  [appConstants.loadCataloguesFailed]: loadCataloguesFailed,
  [appConstants.loadCataloguesSucceeded]: loadCataloguesSucceeded,
  [topNavbarConstants.logoutSucceeded]: logoutSucceeded,
});

export default userReducer;



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/catalogues.js